interface FilterOption {
  label: string;
  value: string;
}

interface FilterGroupProps {
  label: string;
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
}

export default function FilterGroup({ label, options, value, onChange }: FilterGroupProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2.5 sm:gap-4 py-3 border-b border-background-200 last:border-b-0">
      <span className="text-sm text-foreground-500 shrink-0 w-16">{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            className={`px-3.5 py-1.5 rounded-md text-sm transition-colors whitespace-nowrap cursor-pointer ${
              value === opt.value
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-900"
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}